import { Route, Routes } from "react-router-dom";
import AnimalInicio from "pages/Zoonose/Home";
import CreateAnimal from "pages/Zoonose/CreateAnimal";
import EdicaoAnimal from "pages/Zoonose/EditarAnimal";

export const ZoonoseRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AnimalInicio />} />
      <Route path="/create" element={<CreateAnimal />} />
      <Route path="/:idAnimal" element={<EdicaoAnimal />} />
    </Routes>
  );
};
